<template>
  <div class="d-flex column flex-grow overflow-hidden no-shrink" v-loading="$store.state.libLoading">
    <div class="el-main" v-on:scroll="scrollHandler">
      <div class="library-items">
        <el-row v-masonry transition-duration="0s" item-selector=".masonry-item" class="masonry-container" el-row
                type="flex" :gutter="6" justify="center" :width="{'100%': !$store.state.libLoading, '99%': $store.state.libLoading}">
          <el-col v-masonry-tile class="masonry-item" :class="{animate: i>=16}"
                  v-for="item,i in items" :key="item._id" :xs="12" :sm="12" :md="8" :lg="6"
                  :xl="4">
            <library-item v-on:delete="openDeleteModal" v-on:assign="openAssignModal" v-on:share="openShareModal" :item="item" :is-asset="isAsset || item.type==='3D-asset'" />
          </el-col>
        </el-row>
      </div>
      <div class="infinite-scroll-loader"
           style="height: 50px"
           v-loading="true"
           v-if="libLoading && !$store.state.allLoaded"></div>
      <div class="all-loaded" v-if="$store.state.allLoaded">All Items Loaded!</div>
      <el-dialog
          class="signup-modal assign-modal"
          :title="(assignModal.share ? 'Share' : 'Assign' ) + ' tour!'"
          :visible.sync="assignModal.open"
          width="60%"
          center>
        <div class="" v-if="!assignModal.share">Choose class:</div>
        <div>
          <el-select class="w-100" v-model="assignModal.seletedClassId" placeholder="Select"  v-if="!assignModal.share">
            <el-option
                default-first-option="true"
                v-for="item in $store.state.classes"
                :key="item.id"
                :label="item.name"
                :value="item.id">
            </el-option>
          </el-select>
        </div>
        <div>
          <div class="el-input el-input-group el-input-group--prepend">
          </div>
          <div class="input-with-select el-input el-input-group el-input-group--append el-input-group--prepend">
            <a v-if="!assignModal.share" :href="assignLink" target="_blank" class="el-input-group__prepend open-btn">Open</a>
            <div class="el-input__inner link-placeholder" @click="copyToClipboard($event)"><span ref="copyToClipboard">{{assignModal.share ? shareLink : assignLink}}</span>
            </div>
            <div class="el-input-group__append">
              <button @click="copyToClipboard($event, true)" type="button" class="el-button el-button--default"
                      title="Copy to clipboard" style="font-size: 18px">
                <img src="/static/copy.svg" alt="" class="icon">
              </button>
            </div>
          </div>
        </div>
        <div class="flex-center" style="padding-top: 20px;" v-if="!assignModal.share">
          <el-button type="primary" @click.prevent='copyToClipboard'>Copy</el-button>
          <el-button type="success" @click.prevent='assignDemo'>Submit</el-button>
        </div>
      </el-dialog>

      <el-dialog
          class="signup-modal assign-modal"
          v-bind:class="{ 'is-deleting': deleteModal.isDeleting }"
          :visible.sync="deleteModal.open"
          :before-close="() => {itemToDelete = null}"
          width="40%"
          center>
        <h3 class="modal-title">Are you sure you want to delete this tour?</h3>
        <div class="flex-center" style="padding-top: 20px;">
          <el-button type="danger" @click.prevent='deleteTour'>DELETE</el-button>
          <el-button type="success" @click.prevent='cancelDeleteTour'>CANCEL</el-button>
        </div>
        <div class="delete-modal-cover">
          <div class="waiting-spinner"></div>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
  import LibraryItem from "./library-item.vue"

  export default {
    name: 'LibraryItems',
    components: {
      LibraryItem,
    },
    props: {
      items: {
        type: Array,
        default: []
      },

      isAsset: {
        type: Boolean,
        default: false
      },
    },
    data() {
      return {
        search: "",
        filterItems: [],
        checkedFilters: [],
        isIndeterminate: true,
        checkAll: false,
        libLoading: false,
        allLoaded: false,
        libraryItems: [],
        assignModal: {
          noClasses: false,
          open: false,
          id: "",
          seletedClassId: "",
        },
        itemToDelete: null,
        deleteModal: {
          open: false,
          id: "",
          isDeleting: false,
        }
      }
    },
//    mounted: function () {
//      if (Object.keys(this.$route.query).length) return;
//      this.axios.get(this.$store.state.API_URL + 'demo?public=1&_start=0&_limit=16')
//        .then((res) => {
//          this.$store.commit("setState", {libraryItems: res.data});
//          this.$store.state.libLoading = false;
//        });
//    },
    methods: {
      assignDemo() {

        this.axios.post(this.$store.state.API_URL + "class/assign/" + this.assignModal.seletedClassId, {demo_id: this.assignModal.id}).then((res) => {
          this.$message({
            message: 'Tour assigned.',
            type: 'success',
            showClose: true,
          });
          this.assignModal.open = false;
        });
      },
      deleteTour() {
        this.deleteModal.isDeleting = true;
        this.axios.delete(this.$store.state.API_URL + "demo/" + this.deleteModal.id).then((res) => {
          this.deleteModal.isDeleting = false;
          this.deleteModal.open = false;
          this.$message({
            message: 'Tour deleted!',
            type: 'success'
          });
          this.$emit("delete-item", this.itemToDelete);
          setTimeout(() => {
            this.$redrawVueMasonry();
          }, 100)
        });
      },
      cancelDeleteTour() {
        this.deleteModal.open = false;
        this.itemToDelete = null;
      },
      openDeleteModal(item) {
        let id = item._id;
        this.itemToDelete = item;
        this.deleteModal.open = true;
        this.deleteModal.id = id;
      },
      openShareModal(id) {
        this.assignModal.id = id;
        this.assignModal.open = true;
        this.assignModal.share = true;
      },
      openAssignModal(id) {
        this.assignModal.noClasses = false;
        this.assignModal.id = id;
        this.assignModal.share = false;
        if (this.$store.state.classes.length) {
          this.assignModal.open = true;
          this.assignModal.seletedClassId = this.$store.state.classes[0].id
        } else {
          this.axios.get(this.$store.state.API_URL + 'class/my')
            .then((res) => {
              this.$store.commit("setState", {classes: res.data});
              this.assignModal.open = true;
              if (!this.$store.state.classes.length) {
                this.assignModal.noClasses = true;
              } else {
                this.assignModal.seletedClassId = this.$store.state.classes[0].id
              }
            });
        }
      },
      handleClick(tab, event) {
        console.log(tab, event);
      },
      scrollHandler(e) {
        if (this.libLoading || this.$store.state.allLoaded) {
          return;
        }
        if (e.target.scrollTop + e.target.offsetHeight + 300 > e.target.scrollHeight) {
          this.libLoading = true;
          // if (!this.$store.state.filters.category.length && !this.$store.state.filters.tag.length && !this.$store.state.search) {
          //   this.axios.get(this.$store.state.API_URL + 'demo?public=1&_start=' + this.$store.state.libraryItems.length + '&_limit=8')
          //     .then((res) => {
          //       if (!res.data.length) {
          //         this.$store.state.allLoaded = true;
          //         return;
          //       }
          //       this.$store.state.libraryItems = [...this.$store.state.libraryItems, ...res.data];
          //       setTimeout(() => {
          //         this.libLoading = false;
          //       }, 200)
          //     });
          // } else {
          this.axios.post(this.$store.state.API_URL + 'demo/filter', {
            filters: this.$store.state.filters,
            search: this.$store.state.search,
            start: this.$store.state.libraryItems.length,
            limit: 64
          }).then(response => {
            console.log(response)
            if (!response.data.length) {
              this.$store.state.allLoaded = true;
              this.libLoading = false;
              return;
            }
            this.$store.state.libraryItems = [...this.$store.state.libraryItems, ...response.data];
            setTimeout(() => {
              this.libLoading = false;
            }, 200)
          });
          // }
        }
      },
      copyToClipboard(e, noselect) {
        let input = this.$refs.copyToClipboard;

        let range = document.createRange();
        range.selectNode(input);
        window.getSelection().removeAllRanges();
        window.getSelection().addRange(range);
        document.execCommand("copy");
        console.log(noselect)
        if (noselect) {
          window.getSelection().removeAllRanges();
        }
        this.$message('Link copied to clipboard!');
      }
    },
    computed: {
      assignLink() {
        return `${window.location.origin}/api/view/` + this.assignModal.id + "?class_id=" + this.assignModal.seletedClassId;
      },
      shareLink() {
        return `${window.location.origin}/api/view/` + this.assignModal.id;
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/library-items.vue